import $ from "jquery";

$(document).delegate('.products\\/list__product-form', 'submit', function(event) {
	event.preventDefault();

	$('.homepage__payment-cover').prop('hidden', false);

	let form = $(this);
	let url = _config.urls.api.orders.create;
	let data = {
		productCode: form.attr('data-product-code'),
		quantity: 1,
	};

	fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	}).then(response => {
		if (response.status !== 200) {
			throw new Error();
		}

		return response.json();
	}).then(data => {
		const stripe = Stripe(_config.stripe.key);
		stripe.redirectToCheckout({
			sessionId: data.stripe.session_id,
		}).then(function (result) {
		});
	}).catch(error => {
		console.log(error);
	}).finally(() => {
		$('.homepage__payment-cover').prop('hidden', true);
	});
});
